// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { updateWishList as updateWishListApi } from "@bg/App/Services/WishListService";
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    addToChainAfter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    CallUpdateWishListApi,
    chain,
    DispatchBeginUpdateWishList,
    DispatchCompleteUpdateWishList,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";

export const XngCallUpdateWishListApi: any = async (props: any) => {
    try {
        props.result.wishList = await updateWishListApi(props.parameter.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

export const XngExecuteOnSuccessCallback: any = (props: any) => {
    if (props.result.wishList) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.result.wishList);
    }
};

export const XngDispatchResetWishList: any = (props: any) => {
    if (props.result.wishList) {
        props.dispatch({
            type: "Data/WishLists/Reset",
        });
    }
};

export const XngHandleApiParameterProperties: typeof DispatchBeginUpdateWishList = props => {
    let groups = props.parameter.apiParameter.wishList?.properties.groups;
    if(!groups) {
        return;
    }
    
    const cleanedGroups = groups.replace(/[\[\]\\"]/g, '');

    // Split the string by commas, trim any extra spaces, and filter duplicates
    const uniqueGroups = [...new Set(cleanedGroups.split(',').map(item => item.trim()))];

    // Join the array back into a string if needed
    groups = uniqueGroups.join(',');
    
    props.parameter.apiParameter.wishList!.properties = {
        ...props.parameter.apiParameter.wishList!.properties,
        groups,
    };
};

replaceInChain(chain, CallUpdateWishListApi, XngCallUpdateWishListApi);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
addToChainAfter(chain, DispatchCompleteUpdateWishList, XngDispatchResetWishList);
addToChainAfter(chain, DispatchBeginUpdateWishList, XngHandleApiParameterProperties);